/**
 * Product tabs - event delegation for DESCRIPTION, CUSTOMIZING, MATERIALS
 * Works with dynamically loaded content (product swap, etc.)
 */
document.addEventListener('click', (event) => {
  const tab = event.target.closest('.product-tabs__tab');
  if (!tab) return;

  const container = tab.closest('.product-tabs');
  if (!container) return;

  event.preventDefault();
  const target = tab.dataset.tab;

  container.querySelectorAll('.product-tabs__tab').forEach((t) => {
    t.classList.toggle('product-tabs__tab--active', t === tab);
    t.setAttribute('aria-selected', t === tab ? 'true' : 'false');
  });

  container.querySelectorAll('.product-tabs__panel').forEach((p) => {
    const isActive = p.dataset.panel === target;
    p.classList.toggle('product-tabs__panel--active', isActive);
    p.hidden = !isActive;
  });
});
